import { THEME_ACTIVE, CLEAR_REDUX } from "../actionTypes";

const initialState = {
    themeActive: ""
}

export const themeReducer = (state = initialState, action) => {
    switch (action.type) {
        case THEME_ACTIVE:
            return {
                ...state,
                themeActive: action.payload,
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}